import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isEqual, isEmpty } from 'lodash';
import { Container } from 'web-ui-components/lib/global/layout';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { SimplePanel } from 'web-ui-components/lib/layout/content';
import RatePreReviewSection from '../RatePreReviewSection/RatePreReviewSection';
import RateReviewSection from '../RateReviewSection/RateReviewSection';
import content, { contentPropTypes } from './RateBox.content';
import withContent from '../../../../containers/withContent';
import { isRatesApiInProgress } from '../../../../states/rates/selectors';
import { fetchRates } from '../../../../states/rates/actions';
import { getIFTSelectedPayment } from '../../../../states/ift/selectors';
import { setAmountWithDecimalPlace } from '../../../../helpers/fieldHelpers';
import { getCurrencyDecimalPlaces } from '../../../../utils/countryUtils';
import { isPaymentInEditMode } from '../../../../states/modes/selectors';
import { isFormValidForRatesApiCall } from '../../../../states/validation/selectors';

const mapState = (state) => ({
	payment: getIFTSelectedPayment(state),
	isPaymentInEditMode: isPaymentInEditMode(state),
	isRatesApiInProgress: isRatesApiInProgress(state),
	isFormValid: isFormValidForRatesApiCall(state),
});
const mapDispatch = (dispatch) => ({
	fetchRates: (payment) => dispatch(fetchRates(payment)),
});

export const isPaymentsObjEqual = (payment, nextPayment) => {
	const { sendAmount: amount, ...paymentWithoutAmount } = payment;
	const { sendAmount: nextAmount, ...nextPaymentWithoutAmount } = nextPayment;

	const currencyDecimalPlaces = getCurrencyDecimalPlaces(payment.sendCurrency);

	return (
		isEqual(paymentWithoutAmount, nextPaymentWithoutAmount) &&
		isEqual(
			setAmountWithDecimalPlace(amount, currencyDecimalPlaces),
			setAmountWithDecimalPlace(nextAmount, currencyDecimalPlaces)
		)
	);
};

export const shouldFetchRates = (props, nextProps) => {
	const {
		payment: { rates, reason, ...payment },
	} = props;
	const {
		payment: { rates: nextPropsRates, reason: nextPropsReason, ...nextPropsPayment },
	} = nextProps;

	return !isPaymentsObjEqual(payment, nextPropsPayment) && nextProps.isFormValid;
};

export class RateBox extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rateNeverFetched: true,
			rateNeedsRefreshed: true,
		};

		this.handleFetchRate = this.handleFetchRate.bind(this);
	}

	componentDidMount() {
		const { fetchRates, payment, isFormValid, isPaymentInEditMode } = this.props;
		if (isFormValid || isPaymentInEditMode) {
			fetchRates(payment);
		}
	}
	componentWillReceiveProps(nextProps) {
		const { updateRefreshRequired } = this.props;
		const {
			payment: { sendAmount: amount },
		} = nextProps;

		const rateNeedsRefreshed = !isEmpty(amount) && shouldFetchRates(this.props, nextProps);
		if (rateNeedsRefreshed) {
			this.setState({
				rateNeedsRefreshed: true,
			});
			updateRefreshRequired(true);
		}
	}

	handleFetchRate() {
		const { fetchRates, payment, isFormValid, isPaymentInEditMode, updateRefreshRequired, onFreshRateReceived } =
			this.props;

		if (isFormValid || isPaymentInEditMode) {
			return fetchRates(payment).then(() => {
				this.setState({
					rateNeverFetched: false,
					rateNeedsRefreshed: false,
				});
				updateRefreshRequired(false);
				onFreshRateReceived();
			});
		}

		return null;
	}

	render() {
		const {
			isFormValid,
			sendCurrency,
			fromCurrency,
			chargingModal,
			isRatesApiInProgress,
			isPreBookedRate,
			isPreBookedRateMandatory,
			content,
		} = this.props;
		const { rateNeedsRefreshedBtn, rateNeedsRefreshedMessage } = content;

		const { rateNeedsRefreshed, rateNeverFetched } = this.state;
		return (
			<Container size="sm">
				<LoadingLocalTakeover show={isRatesApiInProgress} title="Getting the best rate...">
					<SimplePanel>
						{!isFormValid && (
							<RatePreReviewSection
								isPreBookedRate={isPreBookedRate}
								isPreBookedRateMandatory={isPreBookedRateMandatory}
							/>
						)}
						{isFormValid && (
							<span>
								<center className="u-margin-bottom-2">
									<Button
										disabled={!rateNeedsRefreshed}
										id="rateRefreshBtn"
										display="primary"
										onClick={this.handleFetchRate}
									>
										{rateNeedsRefreshedBtn}
									</Button>
								</center>
								{rateNeedsRefreshed && !rateNeverFetched && (
									<HighlightTile type="info">
										<div>
											<p>{rateNeedsRefreshedMessage}</p>
										</div>
									</HighlightTile>
								)}
								{!rateNeedsRefreshed && (
									<RateReviewSection
										sendCurrency={sendCurrency}
										fromCurrency={fromCurrency}
										chargingModal={chargingModal}
									/>
								)}
							</span>
						)}
					</SimplePanel>
				</LoadingLocalTakeover>
			</Container>
		);
	}
}

RateBox.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	sendCurrency: PropTypes.string.isRequired,
	fromCurrency: PropTypes.string.isRequired,
	chargingModal: PropTypes.string.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	isRatesApiInProgress: PropTypes.bool.isRequired,
	isPreBookedRate: PropTypes.bool.isRequired,
	fetchRates: PropTypes.func.isRequired,
	payment: PropTypes.shape({}),
	isPreBookedRateMandatory: PropTypes.bool.isRequired,
	isPaymentInEditMode: PropTypes.bool.isRequired,
	updateRefreshRequired: PropTypes.func.isRequired,
	onFreshRateReceived: PropTypes.func.isRequired,
};
export const connectWrapper = connect(mapState, mapDispatch)(RateBox);
export default compose(withContent({ content }))(connectWrapper);
